import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';

import {
  IPromotionChartData,
  IPromotionData,
} from './promotion-progression.interface';

@Component({
  selector: 'app-promotion-progression',
  templateUrl: './promotion-progression.component.html',
  styleUrls: ['./promotion-progression.component.scss'],
})
export class PromotionProgressionComponent implements OnInit {
  public promotionProgression!: IPromotionChartData[];
  loading:boolean = false;
  constructor(
    private homeServiceRef: HomeService,
    private route: ActivatedRoute
  ) {}

  getDate(date: string) {
    let datePipe = new DatePipe('en-US');
    return datePipe.transform(date, 'MMM d, y');
  }

  ngOnInit(): void {
    this.loading = true;
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.homeServiceRef.getPromotionProgression(id).subscribe((res) => {
        this.promotionProgression = res.promotionAndProgression.map(
          (progression: IPromotionData, index: number) => {
            return {
              group: this.getDate(progression.occurenceDate),
              field1: progression.promotionCount,
              field2: progression.progressionCount,
            };
          }
        );
        this.loading = false;
      });
    }
  }
  columns = ['group', 'field1', 'field2'];
  colors = ['#377dc7', '#5bb362'];
  legends = ['Promotion', 'Progression'];

}
